import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
  selector: 'app-approaches',
  templateUrl: './approaches.component.html',
  styleUrls: ['./approaches.component.scss'],
})
export class ApproachesComponent implements OnInit {
  constructor(private renderer: Renderer2, private analyticsService: AnalyticsService,private route: ActivatedRoute) {}

  ngOnInit() {
    this.analyticsService.event('approaches_view');
    this.route.queryParams.subscribe(params => {
      if (params && params.appr_section == 'true') {
        this.scrollToApproaches('auto')
      }
    });
  }

  scrollToApproaches(scrollBehavior = 'smooth'): void {
    const el = this.renderer.selectRootElement('#approaches-scroll-target');
    el.scrollIntoView({ behavior: scrollBehavior, block: 'start', inline: 'nearest' });
  }

  trackEvent(name: string, p: any): void {
    if (p) {
      this.analyticsService.event(name, p);
    } else {
      this.analyticsService.event(name);
    }
  }
}
